var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCoin = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 23,
    fill: "none",
    viewBox: "0 0 22 23",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.009 2.02a9.4 9.4 0 0 1 3.828.808l1.14-1.14A10.9 10.9 0 0 0 11.01.5a10.9 10.9 0 0 0-4.97 1.188l1.14 1.14a9.4 9.4 0 0 1 3.83-.807m0 18.96a9.4 9.4 0 0 1-3.829-.808l-1.14 1.14a10.9 10.9 0 0 0 4.969 1.188c1.787 0 3.475-.428 4.968-1.187l-1.14-1.141a9.4 9.4 0 0 1-3.828.808m-11-9.48c0-1.786.428-3.475 1.187-4.968l1.141 1.142A9.4 9.4 0 0 0 1.53 11.5a9.4 9.4 0 0 0 .808 3.827l-1.141 1.141A10.9 10.9 0 0 1 .008 11.5M20.82 6.532l-1.141 1.14c.52 1.171.809 2.467.809 3.828a9.4 9.4 0 0 1-.809 3.828l1.141 1.141a10.94 10.94 0 0 0 1.187-4.969c0-1.787-.428-3.475-1.187-4.968M3.041 11.5c0-4.393 3.574-7.967 7.968-7.967 4.392 0 7.966 3.574 7.966 7.967s-3.573 7.967-7.966 7.967S3.04 15.893 3.04 11.5m10.108 2.364a.38.38 0 0 0 .542 0l1.589-1.589-4.194-4.193-4.35 4.35 1.443 1.442a.38.38 0 0 0 .473.052l2.28-2.28z",
    clipRule: "evenodd"
  })));
};
export default SvgCoin;